import { render, staticRenderFns } from "./EnderecoNumeroField.vue?vue&type=template&id=64a14cc6&scoped=true&"
import script from "./EnderecoNumeroField.vue?vue&type=script&lang=js&"
export * from "./EnderecoNumeroField.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoNumeroField.vue?vue&type=style&index=0&id=64a14cc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a14cc6",
  null
  
)

export default component.exports